export class DashboardDashletModel {
    id: number;
    title: string;
    visible: boolean;
    icon: string;
    url: string;
    color: string;
    type: DashboardDashletType;
    content: any;
    index?: number;
    authority: string;
    showForward: boolean = true;
}

export enum DashboardDashletType {
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
}
